import { render } from "./OrderReturnDeclaredFailure.vue?vue&type=template&id=5e59a058&scoped=true&ts=true&lang=pug"
import script from "./OrderReturnDeclaredFailure.vue?vue&type=script&lang=ts"
export * from "./OrderReturnDeclaredFailure.vue?vue&type=script&lang=ts"

import "./OrderReturnDeclaredFailure.vue?vue&type=style&index=0&id=5e59a058&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e59a058"]])

export default __exports__